import {
  useScoreReducer,
  ScoreContext,
  ScoreDispatchContext,
} from "app/score/useScore";

export function ScoreProvider(props: React.PropsWithChildren) {
  const [scoreState, dispatch] = useScoreReducer();
  return (
    <ScoreContext value={scoreState}>
      <ScoreDispatchContext value={dispatch}>
        {props.children}
      </ScoreDispatchContext>
    </ScoreContext>
  );
}
